import React, { useState, useEffect } from 'react';
import ApiRequest from '../utils/api-request';
import { MODULES_NAMES } from '../modules/modulesList';
import logger from '../utils/logger';

export const HolidaysContext = React.createContext({});

type Props = {
  children: React.Node,
};

export const HolidaysProvider = (props: Props) => {
  const [holidays, setHolidays] = useState([]);

  const getHolidays = async () => {
    try {
      const res = await ApiRequest.get(MODULES_NAMES.HOLIDAYS);
      res && res.data && res.data.Holidays && setHolidays(res.data.Holidays);
    } catch(error) {
      logger.error(`Error loading holidays ${error}`);
    }
  };

  useEffect(() => {
    getHolidays();
  }, [])
  
  return (
    <HolidaysContext.Provider value={{ holidays }}>
      {props.children}
    </HolidaysContext.Provider>
  )
}
